<template>
  <div class="invitation-container">
    <img :src="backgroundImage" alt="Wedding Invitation" class="full-invitation-image" />

    <!-- Overlay guest name -->
    <div class="guest-name">
      {{ guestName }}
    </div>

    <!-- Transparent clickable area over the button in cover_v2.png -->
    <div class="button-overlay" @click="goToBody"></div>
  </div>
</template>

<script>
import backgroundImage from "../assets/cover_v2.png";
import API from "../services/api";

export default {
  name: "WeddingInvitationSection",
  data() {
    return {
      backgroundImage,
      guestName: ""
    };
  },
  async created() {
    const params = new URLSearchParams(window.location.search);
    const guestId = params.get("id");

    if (guestId) {
      try {
        const res = await API.get(`/guests/${guestId}`);
        this.guestName = res.data.name;
      } catch (err) {
        console.error("Failed to fetch guest:", err.response?.data || err.message);
        this.guestName = "";
      }
    }
  },
  methods: {
    goToBody() {
      this.$router.push("/body");
    }
  }
};
</script>

<style scoped>
.invitation-container {
  position: relative;
  width: 100%;
}

.full-invitation-image {
  width: 100%;
  height: auto;
}

.guest-name {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 100%;
  font-weight: bold;
  color: #7b7e5e;
  text-align: center;
  max-width: 80%;
  text-shadow: -1px -1px 0 #feffa5, -1px 1px 0 #feffa5;
}

/* Transparent clickable area over the drawn button */
.button-overlay {
  position: absolute;
  bottom: 2%;   /* adjust to match button position */
  left: 50%;
  transform: translateX(-50%);
  width: 100%;  /* adjust to match button width */
  height: 20%;  /* adjust to match button height */
  cursor: pointer;
}
</style>
